<style scoped>
.explain {
  background: #fff;
  border-radius: 4px;
  text-align: left;
  margin: 20px 14px;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.explain-header {
  padding: 20px 0;
  overflow: hidden;
  /* border-bottom: 1px solid #ccc; */
}
.explain-header b {
  font-size: 20px;
  font-weight: 400;
  color: #323233;
}
.explain-contain {
  padding: 20px 20px 30px 60px;
}
.explain-title {
  /* width: 130px; */
  display: inline-block;
}
.cost-img {
  width: 300px;
}
.state-approval {
  font-size: 12px;
  display: inline-block;
  padding: 3px 10px 4px 10px;
  border-radius: 10px;
  margin-left: 20px;
}

.now-state {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}
.state-now-pass {
  color: #fff;
  background: #4fa1a4;
}
.state-now-unpass {
  color: red;
  border: 1px solid red;
}
.state-now-revoke {
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
.approval {
  margin: 10px 10px 60px 10px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
  padding: 30px 60px 60px 60px;
}
.approval-list {
  display: flex;
}
.list-left {
  margin-right: 10px;
}
.left-box {
  width: 55px;
  height: 55px;
  color: #fff;
  line-height: 51px;
  background: #999;
  text-align: center;
  border-radius: 4px;
  margin: 0px 10px;
}
.left-line {
  width: 0.5px;
  height: 40px;
  background: #999;
  margin-left: 37px;
}
.approval-list:last-child .list-left .left-line {
  display: none;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}
.state-now {
  color: #e59940;
  background: rgba(255, 242, 224, 0.23);
  /* border: 1px solid #e59940; */
  /* border: 1px solid #C8C9CD; */
}
.state-pass {
  color: #4fa1a4;
  background: rgba(79, 161, 164, 0.1);
  /* border: 1px solid #4fa1a4; */
}
.state-reject {
  color: rgb(255, 85, 85);
  background: rgba(255, 85, 85, 0.07);
  /* border: 1px solid rgb(255, 85, 85); */
}
.state-undo {
  color: rgb(197, 202, 213);
  background: #fff;
  border: 1px solid rgb(197, 202, 213);
}
.title-pass {
  background: #4fa1a4 !important;
}
.title-reject {
  background: red !important;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  display: inline-block;
  /* line-height: 30px; */
}
.link-active {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.doc-img {
  width: 80px;
  height: 80px;
  margin-right: 24px;
  /* margin-bottom: 10px; */
  cursor: pointer;
}
.doc-img img {
  width: 80px;
  height: 80px;
}
.img-name {
  width: 80px;
  line-height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: default;
}
.cost-plan-box {
  width: 80%;
  display: flex;
  padding: 12px 14px 12px 24px;
  margin-top: 20px;
  background: rgba(247, 247, 247, 0.39);
}
.cost-plan-left {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.plan-left-list {
  width: 50%;
  margin-bottom: 8px;
}
.plan-left-name {
  color: #2f2f2f;
  margin-right: 12px;
}
.plan-left-content {
  color: #2f2f2f;
}
.cost-plan-right {
  width: 90px;
  font-size: 16px;
  color: #4fa1a4;
  cursor: pointer;
}
.edit-plan-box span{
  color: red;
}
.edit-plan-box .el-col-12{
  display: flex;
  margin-bottom: 10px;
}
.edit-plan-box .el-col-24{
  display: flex;
}
.edit-plan-box .el-col-24 .search-area-div{
  width: 100px;
  line-height: 20px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 10px;
}
.edit-plan-box .el-col-12 .search-area-div{
  width: 100px;
  line-height: 20px;
  flex-shrink: 0;
  text-align: right;
  padding-right: 10px;
}
.edit-plan-content{
  text-align: left;
}
.search-area-div{
  width: 100px;
  font-size: 14px;
  padding-right: 10px;
  text-align: right;
}
</style>
<template>
  <div class="approval-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="explain">
      <div class="explain-header">
        <b class="font-S20">{{ flowName }}</b>
        <span class="state-approval state-now" v-if="academicDetail.approveState == 'N' || academicDetail.approveState == 'A'">审批中</span>
        <span class="state-approval state-pass" v-if="academicDetail.approveState == 'Y'">已通过</span>
        <span class="state-approval state-reject" v-if="academicDetail.approveState == 'R'">已驳回</span>
        <span class="state-approval state-undo" v-if="academicDetail.approveState == 'C'">已撤销</span>
        <span :class="academicDetail.approveState == 'Y' ? 'state-back fr' : 'state-back fr ml30'" @click="$router.go(-1)">返回</span>
        <span class="state-back fr mr15 ml30" v-if="academicDetail.approveState == 'Y'" @click="toPrinting()">打印</span>
        <span class="now-state state-now-unpass fr mr15" v-if="approveStaffGuid == staffGuid && (academicDetail.approveState == 'N' || academicDetail.approveState == 'A')" @click="toReject()">驳回</span>
        <span class="now-state state-now-pass fr mr15" v-if="approveStaffGuid == staffGuid && (academicDetail.approveState == 'N' || academicDetail.approveState == 'A')" @click="toPass()">通过</span>
        <span class="now-state state-now-pass fr mr15" v-if="academicDetail.approveState == 'R' && academicDetail.staffGuid == staffGuid" @click="reSubmit()">重新提交</span>
        <span class="now-state state-now-revoke fr mr15" v-if="academicDetail.approveState == 'N' && academicDetail.staffGuid == staffGuid" @click="toRevoke()">撤销</span>
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">申请信息</span>
      </div>
      <div class="explain-contain">
        <div class="explain-item">
          <span class="explain-title">学术计划：</span> <span class="explain-content">{{ academicDetail.academicActivityPlanTitle }}</span>
        </div>
        <div class="cost-plan-box">
            <div class="cost-plan-left">
              <div class="plan-left-list">
                <span class="plan-left-name">产品名称</span><span class="plan-left-content">{{planForm.goodsInfoList&&planForm.goodsInfoList.length?getGoodsName(planForm.goodsInfoList):planForm.goodsName}}</span>
              </div>
              <div class="plan-left-list">
                <span class="plan-left-name">科室名称</span><span class="plan-left-content">{{planForm.deptName}}</span>
              </div>
              <div class="plan-left-list w100f">
                <span class="plan-left-name">会议目的</span><span class="plan-left-content">{{planForm.activityPurpose}}</span>
              </div>
            </div>
            <div class="cost-plan-right" @click="lookPlan">查看计划</div>
        </div>
        <div class="explain-item">
          <span class="explain-title">申请人：</span> <span class="explain-content">{{ academicDetail.staffName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">提交时间：</span>
          <span class="explain-content">{{ academicDetail.createTime | getTime }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所在部门：</span>
          <span class="explain-content">{{ academicDetail.organisationName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所属公司：</span>
          <span class="explain-content">{{ academicDetail.tenantName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">计划费用：</span>
          <span class="explain-content">{{ academicDetail.planCost | numDigit }} 元</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">大写金额：</span>
          <span class="explain-content">{{ academicDetail.planCost | smallToBig }}</span>
        </div>
         <div class="explain-item">
          <span class="explain-title">实际费用：</span>
          <span class="explain-content">{{ academicDetail.realCost | numDigit }} 元</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">大写金额：</span>
          <span class="explain-content">{{ academicDetail.realCost | smallToBig }}</span>
        </div>
        <div class="explain-item clear-hidden">
          <span class="explain-title fl">签到表：</span>
          <template v-for="(item, index) in imgList">
            <div class="img-block" v-if="imgList" :key="index">
              <el-tooltip class="item" effect="dark" :content="item.name || item.fileName" placement="right">
                <el-image style="width: 80px; height: 80px; margin-right: 24px" :src="item.path" :preview-src-list="imgPreviewList"></el-image>
              </el-tooltip>
            </div>
          </template>
          <template v-for="(item, index) in docList">
            <div class="doc-img" v-if="docList" :key="index">
              <el-tooltip class="item" effect="dark" :content="item.name" placement="right">
              <img :src="item.icon" alt="" @click="toFile(item.path)" />
              </el-tooltip>
            </div>
          </template>
        </div>
      </div>
      <div class="cost-title-list mb25">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">流程审批</span>
      </div>
      <flowList :approvalList="approvalList" :carbonName="carbonName" :approveState="academicDetail.approveState"></flowList>
    </div>
    <div class="h20"></div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
      </el-dialog> 
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog> 
    <el-dialog title="文件查看" :visible.sync="dialogVisibleFile" fullscreen>
      <!-- <span>这是一段信息</span> -->
      <iframe style="width: 100%; height: calc(100vh - 84px)" :src="src" frameborder="0"></iframe>
    </el-dialog>
    <printDialog :showPrintDialog.sync='showPrint' :printType="4" :printData="academicDetail" :approvalList="approvalList" @closePrint="closePrint"></printDialog>
    <!-- 计划详情 -->
    <el-dialog width="960px" :visible.sync="editPlanVisible" :close-on-click-modal="false" title="计划详情">
      <div class="edit-plan-box">
        <el-row :gutter="24" class="mb15">
          <el-col :span="12"
            ><div class="search-area-div">医院名称 :</div>
            <div class="edit-plan-content">{{planForm.medName}}</div>
          </el-col>
          <el-col :span="12"
            ><div class="search-area-div">科室名称 :</div>
            <div class="edit-plan-content">{{planForm.deptName}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb15">
          <el-col :span="12"
            ><div class="search-area-div">产品名称 :</div>
            <div class="edit-plan-content">{{planForm.goodsInfoList&&planForm.goodsInfoList.length?getGoodsName(planForm.goodsInfoList):planForm.goodsName}}</div>
          </el-col>
          <el-col :span="12"
            ><div class="search-area-div">会议类型 :</div>
            <div class="edit-plan-content">{{planForm.activityType}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb15">
          <el-col :span="12"
            ><div class="search-area-div">会议级别 :</div>
            <div class="edit-plan-content">{{planForm.activityLevel}}</div>
          </el-col>
          <el-col :span="12"
            ><div class="search-area-div">参会人数 :</div>
            <div class="edit-plan-content">{{planForm.staffCount}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb30">
          <el-col :span="24"
            ><div class="search-area-div">讲者姓名 :</div>
            <div class="edit-plan-content">{{planForm.speakerName}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb30">
          <el-col :span="24"
            ><div class="search-area-div">会议目的 :</div>
            <div class="edit-plan-content">{{planForm.activityPurpose}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb30">
          <el-col :span="24"
            ><div class="search-area-div">跟进目标 :</div>
            <div class="edit-plan-content">{{planForm.followTarget}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mb30">
          <el-col :span="24"
            ><div class="search-area-div">跟进计划及时间 :</div>
            <div class="edit-plan-content">{{planForm.followTime}}</div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="editPlanVisible = false">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import flowList from '@/components/flowList.vue';
import printDialog from '@/components/printDialog.vue';
export default {
  components: {
    flowList,
    printDialog
  },
  data() {
    return {
      rejectDialogVisible:false,
      passDialogVisible:false,
      editPlanVisible:false,
      dialogVisibleFile:false,
      academicDetail: {},
      approveSuggest: '',
      flowName: '学术活动',
      carbonName: '',
      approvalList: [],
      approveStaffGuid: '',
      staffGuid: '',
      imgList: [],
      url: '',
      flowType: '00005',
      fullscreenLoading: false,
      docList: [],
      src: '',
      imgPreviewList: [],
      showPrint:false, //打印
      medOption: [], //商业公司
      medDeptOption:[],//科室
      goodsOption:[],//产品
      meetingTypeOption: [],//会议类型
      meetingTypeLevel: ['A','B'],//会议级别
      planForm:{
        guid: null,
        tenantGuid: localStorage.guid,
        tenantName: null,
        accountMonth: null,
        staffGuid: null,
        staffName: null,
        parentGuid:null,//父ID
        activityType: null,//活动类型
        activityLevel: null,//活动级别
        medGuid: null,
        medName: null,//医院名称
        deptGuid: null,
        deptName: null,//科室名称
        goodsGuid: null,
        goodsName: null,//产品名称
        staffCount: null,//参加人数
        activityPurpose: null,//活动目的
        speakerName: null,//讲者姓名
        followTarget: null,//跟进目标
        followTime: null,//跟进计划及时间
        goodsInfoList:[]
      },
      goodsInfoList:[]
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid = userinfo.staffGuid;
    this.approveStaffGuid = this.$route.query.approveStaffGuid;
    this.getData();
    this.getApprovalList();
    console.log(this.imgList);
  },
  methods: {
    getGoodsName(res) {
      var list = [];
      if (res.length >= 2) {
        res.forEach((item, index) => {
          if (index <= 1) {
            list.push(item.goodsName);
          }
        });
        return list.join("、") + "等" + res.length + "个产品";
      } else {
        return res[0].goodsName;
      }
    },
    //打印
    closePrint(){
      this.showPrint = false
    },
    lookPlan(){
      this.editPlanVisible = true;
    },
    //获取计划详情
    getPlanDetail(guid){
      let that = this;
      that.api.get(
        `/${serverConfig.msSalesPerformService}/academic-activity/plan/detail/${guid}`
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          this.planForm = data;
          this.goodsInfoList = [];
          if(data.goodsInfoList){
            data.goodsInfoList.forEach(i=>{
              this.goodsInfoList.push(i.goodsGuid)
            })
          }else{
            this.goodsInfoList = [data.goodsGuid];
          }
        } else {
          this.$message.error(res.data.data.msg);
        }
      });

    },
    getData() {
      let self = this;
      this.fullscreenLoading = true;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/academic-activity/activity/detail/` + self.$route.query.bizGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            self.academicDetail = res.data.data;
            self.academicDetail.academicActivityPlanTitle = this.$route.query.academicActivityPlanTitle || '-';
            self.academicDetail.organisationName = this.$route.query.organisationName || '-';
            self.academicDetail.tenantName = this.$route.query.tenantName || '-';
            self.getPlanDetail(self.academicDetail.academicActivityPlanGuid)
            self.imgList = [];
            if (res.data.data.signFile !== null) {
              let signFile = JSON.parse(res.data.data.signFile);
              signFile.forEach((item) => {
                if (
                  item.path.indexOf('.jpg') > -1 ||
                  item.path.indexOf('.png') > -1 ||
                  item.path.indexOf('.jpeg') > -1 ||
                  item.path.indexOf('.jfif') > -1 ||
                  item.path.indexOf('.gif') > -1
                ) {
                  self.imgList.push(item);
                  self.imgPreviewList.push(item.path);
                } else if (item.path.indexOf('.doc') > -1 || item.path.indexOf('.docx') > -1) {
                  item.icon = require('../../assets/images/word_icon.png');
                  self.docList.push(item);
                } else if (item.path.indexOf('.xls') > -1 || item.path.indexOf('.xlsx') > -1) {
                  item.icon = require('../../assets/images/excel_icon.png');
                  self.docList.push(item);
                }
              });
              console.log(self.imgList);
            }
            this.fullscreenLoading = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //查看文件
    toFile(path) {
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(path),'_blank');
    },
    //获取流程列表
    getApprovalList() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/approve/data/get-flow-running-node?flowType=00005&guid=` + self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.approvalList = res.data.data;
            self.approvalList.sort((n1, n2) => {
              return n1.orderNum - n2.orderNum;
            });
            if(res.data.data[0].ccGuids&&JSON.parse(res.data.data[0].ccGuids).length>0){
              self.carbonName = JSON.parse(res.data.data[0].ccGuids)[0].name;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //打印
    toPrinting() {
      this.showPrint = true
      // let self = this;
      // self.$router.push({
      //   path: '/reportProcess',
      //   query: {
      //     guid: self.$route.query.guid,
      //     flowType: '00001',
      //   },
      // });
    },

    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.$route.query.guid,
            flowType: self.flowType,
            approveStaffGuid:self.staffGuid
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/costApprove',
        query: {
          bizGuid:this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          productGuid:this.$route.query.productGuid
        },
      });
    },
    toPass(){
      let self = this;
      self.approveSuggest =""
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest =""
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/allow-flow`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('审批通过！');
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/backup-flow`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('驳回成功！');
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
